'use strict';
angular
    .module('MW.ContactManager.ContactManagerFlashService', [
        'MW.Influencers.IcmDialogService',
        'MW.Framework.ErrorMessageService',
        'MW.Framework.TranslationService'
    ])
    .service('ContactManagerFlashService', [
        'DialogService',
        'ErrorMessageService',
        'translationService',
        function(DialogService, ErrorMessageService, translationService) {
            var flashTimeout = 0; // 0 disables the timeout

            this.flashError = function flashError(err, message, messageParams) {
                var errorStatusCode,
                    errorMessageObject;

                if(message) {
                    messageParams = messageParams || false;
                    DialogService.flashError(translationService.getLocalizedString(message, messageParams), flashTimeout);
                } else {
                    errorStatusCode = ((err && err.statusCode) ? err.statusCode : 500);
                    errorMessageObject = ErrorMessageService.getErrorMessageFromStatusCode(errorStatusCode);

                    DialogService.flashError(errorMessageObject.message, flashTimeout);
                }
            };

            this.flashSuccess = function flashSuccess(message) {
                DialogService.flashSuccess(translationService.getLocalizedString(message));
            };

            this.flashWarning = function flashWarning(message) {
                DialogService.flashWarning(translationService.getLocalizedString(message));
            };
        }
    ]);